import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LogIn, ArrowLeft, ExternalLink } from 'lucide-react';
interface NavbarProps {
  onJoinBeta: () => void;
  showBackButton?: boolean;
  onBackClick?: () => void;
}
export const Navbar = ({
  onJoinBeta,
  showBackButton,
  onBackClick
}: NavbarProps) => {
  const navigate = useNavigate();
  const handleAuth = () => {
    navigate('/auth');
  };
  return <nav className="fixed top-0 w-full bg-white border-b border-gray-100 z-50" data-id="element-1295">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1296">
        <div className="flex justify-between items-center h-16" data-id="element-1297">
          <div className="flex items-center" data-id="element-1298">
            {showBackButton ? <button onClick={onBackClick} className="flex items-center gap-2 text-gray-600 hover:text-[#6366f1] transition-colors" data-id="element-1299">
                <ArrowLeft size={20} data-id="element-1300" />
                Back to Home
              </button> : <span className="text-xl font-bold text-gray-900" data-id="element-1301">
                usegigi.ai
              </span>}
          </div>
          <div className="flex items-center gap-4" data-id="element-1302">
            {!showBackButton && <button onClick={handleAuth} className="px-4 py-2 bg-[#d5ff00] text-gray-900 rounded-lg hover:bg-[#c0e600] flex items-center gap-2 shadow-lg font-semibold" data-id="element-1303">
                <LogIn size={20} data-id="element-1304" />
                Start Free
              </button>}
          </div>
        </div>
      </div>
    </nav>;
};